import React from 'react';
import './mini-navbar.scss';

// accepts items as list, and a function which will get invoked whenever clicked on an item
class MiniNavbar extends React.Component {

    state = {
        selectedItem: this.props.selectedItem
    };

    onClickNavItem = (index) => {

        this.setState({selectedItem: index});
        this.props.onClickItem(index);
    }

    render() {

        return (
            <div className="navbar-container">
                {
                    this.props.items.map((item) => {
                        return <span 
                                className={"item" + (this.props.selectedItem == item.id ? " selected" : "")} 
                                onClick={() => this.onClickNavItem(item.id)}
                                key={item.id}>{item.value}</span>
                    })
                }
            </div>
        );
    }

}

export default MiniNavbar;